import Select from 'components/library/Input/Select/Select';
import SelectOption from 'components/library/Input/Select/SelectOption';
import React from 'react';
import { i18n } from 'utils/translate';

function CriterionSelect({ value, field, options, onChange }) {
    return (
        <Select
            className="targeting__criteria-value"
            value={value[0]}
            label={i18n('campaign_criteria_value')}
            onChange={(event) => onChange(field, event.target.value)}
        >
            {Object.entries(options).map(([optionValue, optionText]) => (
                <SelectOption
                    key={`targeting-field-option-${field}-${optionValue}`}
                    value={optionValue}
                >
                    {optionText}
                </SelectOption>
            ))}
        </Select>
    );
}

export default CriterionSelect;
